import { DELETE_CONTACT, DELETE_CONTACT_FAILURE, DELETE_CONTACT_SUCCESS, GET_CONTACT, GET_CONTACTS, GET_CONTACTS_FAILURE, GET_CONTACTS_SUCCESS, GET_CONTACT_FAILURE, GET_CONTACT_SUCCESS } from "./actionTypes";


export const getContacts = (payload) => {
  return {
    type: GET_CONTACTS,
    payload,
  };
};

export const getContactsSuccess = (payload) => {
  return {
    type: GET_CONTACTS_SUCCESS,
    payload,
  };
};

export const getContactsFailure = (payload) => {
  return {
    type: GET_CONTACTS_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const getContact = (payload) => {
  return {
    type: GET_CONTACT,
    payload,
  };
}

export const getContactSuccess = (payload) => {
  return {
    type: GET_CONTACT_SUCCESS,
    payload,
  };
}

export const getContactFailure = (payload) => {
  return {
    type: GET_CONTACT_FAILURE,
    payload,
  };
}

// ===================================================
// ===================================================

export const deleteContact = (payload) => {

  return {
    type: DELETE_CONTACT,
    payload,
  };
}

export const deleteContactSuccess = (payload) => {
  return {
    type: DELETE_CONTACT_SUCCESS,
    payload,
  };
}

export const deleteContactFailure = (payload) => {
  return {
    type: DELETE_CONTACT_FAILURE,
    payload,
  };
}

// ===================================================
// ===================================================